export const isOnJiraFullPageSearch = (): boolean => {
	return window.location.pathname.includes('/jira/rovo-search');
};
